module.exports = __webpack_public_path__ + "static/carrier-accept-orders-d19f98d36a6c3b519e6fa93576adf534.png";